import moment from "moment-timezone";

export interface DateRangePreset {
  label: string;
  value: string;
  getDateRange: () => { from: Date; to: Date };
}

export const dateRangePresets: DateRangePreset[] = [
  {
    label: "Today",
    value: "today",
    getDateRange: () => {
      const today = moment().toDate();
      return { from: today, to: today };
    },
  },
  {
    label: "This Week",
    value: "this-week",
    getDateRange: () => {
      return {
        from: moment().startOf('isoWeek').toDate(), // Start on Monday
        to: moment().endOf('isoWeek').toDate(),
      };
    },
  },
  {
    label: "Next Week",
    value: "next-week",
    getDateRange: () => {
      return {
        from: moment().add(1, 'week').startOf('isoWeek').toDate(),
        to: moment().add(1, 'week').endOf('isoWeek').toDate(),
      };
    },
  },
  {
    label: "Next 3 Days",
    value: "next-3-days",
    getDateRange: () => {
      return {
        from: moment().toDate(),
        to: moment().add(2, 'days').toDate(),
      };
    },
  },
  {
    label: "Next 14 Days",
    value: "next-14-days",
    getDateRange: () => {
      return {
        from: moment().toDate(),
        to: moment().add(13, 'days').toDate(),
      };
    },
  },
];

export function formatDateForAPI(date: Date): string {
  return moment(date).format("YYYY-MM-DD");
}

export function getDefaultDateRange(): { from: Date; to: Date } {
  return dateRangePresets.find(preset => preset.value === "this-week")!.getDateRange();
}